import { useEffect, useState } from 'react';
import { ISalaAula, IDocente, IHorario, IDisciplinaGradeHorario } from '../../@types/GradeHorarioSalaAula';
import { api, apiServerDac } from '../../services/api';

import { GradeHorarioComponent } from '@/components/PagesComponents/GradeHorario';

const GradeHorario = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);

    // estados para pegar os valores dos inputs/selects
    // const [ano, setAno] = useState<number>(2024);
    const [ano, setAno] = useState(() => new Date().getFullYear());
    const [semestre, setSemestre] = useState<number>(1);
    const [disciplinaSelecionada, setDisciplinaSelecionada] = useState<string>('');
    const [docenteSelecionado, setDocenteSelecionado] = useState<string>('');
    const [diaSemanaSelecionado, setDiaSemanaSelecionado] = useState<string>('');
    const [salaAulaSelecionada, setSalaAulaSelecionada] = useState<string>('');

    const [disciplinas, setDisciplinas] = useState<IDisciplinaGradeHorario[]>([]); //-> Disciplinas

    const [docentes, setdocentes] = useState<IDocente[]>([]); //-> Professores

    const [diasSemana] = useState<Record<string, string>[]>([
        // dias da semana e seus valores
        { name: 'Segunda-Feira', value: '2' },
        { name: 'Terça-Feira', value: '3' },
        { name: 'Quarta-Feira', value: '4' },
        { name: 'Quinta-Feira', value: '5' },
        { name: 'Sexta-Feira', value: '6' }
    ]);

    const [salasAula, setSalasAula] = useState<ISalaAula[]>([]); //-> Salas de aula

    const [horarios, setHorarios] = useState<IHorario[]>([]); // -> Horários


    useEffect(() => {
        // consulta disciplinas por ano e semestre
        const getDisciplinas = async () => {
            // server-dac V2 substitui /disciplinas/alldistinct e retorna array direto.
            const url = `/v2/ofertas_turmas/disciplinas-distinct?ano=${ano}&pturma=${semestre}&tipo=FA`;

            await apiServerDac.get(url)
                .then(response => {
                    setDisciplinas(response.data);
                })
                .catch(err => {
                    console.log(err);
                });
        };

        getDisciplinas();
    }, [ano, semestre]);

    useEffect(() => {
        // consulta docentes e salas de aula para os selects
        const getDocentes = async () => {
            const url = `/user/register/allTipoDocentesAtivos`;

            api.get(url)
                .then(response => setdocentes(response.data))
                .catch(err => {
                    console.log(err);
                });
        };

        const getSalasAula = async () => {
            const url = `/zeladoria/manutencao/local/sigla`;

            api.get(url)
                .then(response => setSalasAula(response.data))
                .catch(err => {
                    console.log(err);
                });
        };

        getDocentes();
        getSalasAula();
    }, []);

    useEffect(() => {
        // consulta grade horária com base nos filtros selecionados
        // server-dac V2 substitui /oferecimento/timetable preservando os campos exibidos na tabela.
        const url = `/v2/ofertas_turmas/timetable?ano=${ano}&cdisc=${disciplinaSelecionada}&cturma&dsem=${diaSemanaSelecionado}&nmatr=${docenteSelecionado}&pturma=${semestre}&csala=${salaAulaSelecionada}`

        setIsLoading(true);

        const getHorarios = async () => {

            await apiServerDac.get(url)
                .then(response => {
                    setHorarios(response.data);
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setIsLoading(false);
                })
        }

        getHorarios();


    }, [ano, disciplinaSelecionada, diaSemanaSelecionado, docenteSelecionado, semestre, salaAulaSelecionada]);


    return (
        <>
            <h1>Grade Horário - Sala Aula</h1>

            <GradeHorarioComponent
                isLoading={isLoading}
                semestre={semestre}
                ano={ano}
                docentes={docentes}
                disciplinas={disciplinas}
                diasSemana={diasSemana}
                salasAula={salasAula}

                docenteSelecionado={docenteSelecionado}
                disciplinaSelecionada={disciplinaSelecionada}
                diaSemanaSelecionado={diaSemanaSelecionado}
                salaAulaSelecionada={salaAulaSelecionada}
                
                setDocenteSelecionado={setDocenteSelecionado}
                setDisciplinaSelecionada={setDisciplinaSelecionada}
                setDiaSemanaSelecionado={setDiaSemanaSelecionado}
                setSalaAulaSelecionada={setSalaAulaSelecionada}
                setSemestre={setSemestre}
                setAno={setAno}
                
                horarios={horarios}
            />

        </>
    );
}

export { GradeHorario };
